import { gql, useQuery } from '@apollo/client';
import LOCALIZED_TEXT_FRAGMENT from 'apollo/fragments/localizedText';
import { QueryListPacksArgs } from 'apollo/generated/types';
import { LocalizedPack } from 'apollo/localizedTypes';

const LIST_PACKS = gql`
  query listPacks($date: String) {
    listPacks(date: $date) {
      id
      name {
        ...LocalizedTextFields
      }
      adultValue
      otherValue
      description {
        ...LocalizedTextFields
      }
      status
      visibility
      activities {
        id
        name
      }
      entranceTicketTypes {
        id
        name {
          ...LocalizedTextFields
        }
      }
      features {
        ticketFeatureId
        slug
        name {
          ...LocalizedTextFields
        }
        status
        availability
        position
        note {
          ...LocalizedTextFields
        }
      }
      packImages {
        id
        image
      }
    }
  }
  ${LOCALIZED_TEXT_FRAGMENT}
`;

const useListPacksQuery = (date?: string) => {
  return useQuery<{ listPacks: LocalizedPack[] }, QueryListPacksArgs>(LIST_PACKS, {
    variables: { date },
  });
};
export default useListPacksQuery;
